import { useState, useEffect } from 'react';
import { fetchFieldOptions, type FieldOption } from '../services/optionsService';

interface Result {
  options: FieldOption[];
  loading: boolean;
}

export function useFieldOptions(fieldName: string, lang: string): Result {
  const [state, setState] = useState<Result>({ options: [], loading: true });

  useEffect(() => {
    let cancelled = false;
    fetchFieldOptions(fieldName, lang)
      .then((data) => {
        if (!cancelled) setState({ options: data, loading: false });
      })
      .catch(() => {
        if (!cancelled) setState({ options: [], loading: false });
      });
    return () => {
      cancelled = true;
    };
  }, [fieldName, lang]);

  return state;
}
